import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast, Slide } from 'react-toastify';

//3rd party
import moment from 'moment';
import { Watch } from  'react-loader-spinner';
import Backdrop from '@mui/material/Backdrop';
import Tooltip from '@mui/material/Tooltip';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css';
import * as Icon from 'react-bootstrap-icons';
import { getWeek } from 'date-fns';

//Functions
import { apiCall, apiError } from '../functions/common';

//Components
import Header from '../components/Header';
import BottomMenu from '../components/BottomMenu';
import DayRowOverview from '../components/DayRowOverview';
import TableRowSkeleton from '../components/TableRowSkeleton';
import ModalModify from '../components/ModalModify';
import ModalOfferHours from '../components/ModalOfferHours';
import Artwork from '../components/Artwork';
import Dropdown from '../components/Dropdown';
import ModalReviewHours from '../components/ModalReviewHours';

//Styles
import '../css/overview.css';

// i18n
import { useTranslations } from '../context/TranslationsContext';

const Overview = () => {
    const { t, loading: i18nLoading } = useTranslations();

    const navigate = useNavigate();
    const loggedIn = localStorage.getItem('ingelogd');
    const functie_id = localStorage.getItem('functie_id');
    if(functie_id != 4){ // Directie
        navigate('/');
    }
    let userId = 0;//localStorage.getItem('user_id');
    if(userId == null){
        userId = 0;
    }
    const code = global.settings.api.code;
    const default_period = 5; //This month = default (3)

    // States
    const [date, setDate] = useState(Date.now());
    const [showDate, setShowDate] = useState(moment().format('DD-MM-YYYY'));
    const [submitDate, setSubmitDate] = useState(moment().format('YYYY-MM-DD'));
    const [registerDate, setRegisterDate] = useState(moment().format('YYYY-MM-DD'));
    const [dateLabel, setDateLabel] = useState(moment().format('LL'));
    const [totals, setTotals] = useState('');
    const [loadingRegistrations, setLoadingRegistrations] = useState(false);
    const [showSkeletonsRegistrations, setShowSkeletonsRegistrations] = useState(true);
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [registrations, setRegistrations] = useState([]);
    const [totalHours, setTotalHours] = useState(0);
    const [checkAll, setCheckAll] = useState(false);
    const [checkedRows, setCheckedRows] = useState({});
    const [checkedIds, setCheckedIds] = useState([]);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [pagination, setPagination] = useState(null);

    // Filters
    const [periods, setPeriods] = useState([]);
    const [selectedPeriod, setSelectedPeriod] = useState(default_period);
    const [selectedWeek, setSelectedWeek] = useState(getWeek(new Date()));
    const [showWeekDropdown, setShowWeekDropdown] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(userId);
    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(0);
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState(0);
    const [construction_numbers, setConstructionNumbers] = useState([]);
    const [selectedConstructionNumber, setSelectedConstructionNumber] = useState(0);
    const [decks, setDecks] = useState([]);
    const [selectedDeck, setSelectedDeck] = useState(0);
    const [hour_types, setHourTypes] = useState([]);
    const [selectedHourType, setSelectedHourType] = useState(0);
    const [statusses, setStatusses] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(0);
    const [activeStatusses, setActiveStatusses] = useState([]);
    const [selectedActiveStatus, setSelectedActiveStatus] = useState(1);

    const [order_by, setOrderBy] = useState('desc');
    const [order_by_name, setOrderByName] = useState('datum');

    const week_numbers = [...Array(52).keys()].map(i => ({
        value: i + 1,
        label: `Week ${i + 1}`,
        actief: 1
    }));

    // Modal variables
    const [showModal, setShowModal] = useState(0);
    const [modalData, setModalData] = useState([]);

    const [showModalOfferHours, setShowModalOfferHours] = useState(0);
    const [modalDataOfferHours, setModalDataOfferHours] = useState([]);

    // Get user registrations
    const getRegistrations = async (type) => {
        setLoadingRegistrations(true);
        if (type === 'skeleton') { setShowSkeletonsRegistrations(true) }
        //setTotals('');
        try {
            const response = await apiCall(`registraties/overzicht?code=${code}
                &periode_id=${selectedPeriod}
                &week_number=${selectedWeek}
                &employee_id=${selectedEmployee}
                &location_id=${selectedLocation}
                &client_id=${selectedClient}
                &construction_number_id=${selectedConstructionNumber}
                &deck_id=${selectedDeck}
                &hour_type_id=${selectedHourType}
                &status_id=${selectedStatus}
                &active_status_id=${selectedActiveStatus}
                &page=${page}
                &per_page=${perPage}
            `);
            // Success
            if (response.data.success) {
                const data = response.data.data;
                console.log(data);
                setRegistrations(data.registraties);
                setTotalHours(data.totaal_uren);
                setPagination(data.pagination);
                setPeriods(data.periods);
                setEmployees(data.employees);
                setLocations(data.locations);
                setClients(data.clients);
                setConstructionNumbers(data.construction_numbers);
                setDecks(data.decks);
                setHourTypes(data.hour_types);
                setStatusses(data.statusses);
                setActiveStatusses(data.active_statusses);

                /*if(data.registratie.totaal_uren){
                    setTotals((Math.round(data.registratie.totaal_uren * 100) / 100).toFixed(2));
                } else {
                    setTotals('');
                }*/

                setOpenBackdrop(false);
                setShowModal(false);
                setShowModalOfferHours(false);
                setShowSkeletonsRegistrations(false);
                setLoadingRegistrations(false);
            }
        } catch (error) {
            // Error
            apiError(error);
        }
    }

    /*const handleChangeDate = (value) => {
        setRegisterDate(moment(value.$d).format('YYYY-MM-DD'));
        setDateLabel(moment(value.$d).format('LL'));
        getRegistrations(moment(value.$d).format('YYYY-MM-DD'), 'skeleton');
        setSubmitDate(moment(value.$d).format('YYYY-MM-DD'));
        setShowDate(moment(value.$d).format('DD-MM-YYYY'));
    }*/

    
    const deleteRow = async (id, row_id) => {
        //console.log("Deleterow");
        setShowSkeletonsRegistrations(true);
        //Call API
        try {
            const response = await apiCall(`registratie/${id}/verwijderen?code=${code}&rij_id=${row_id}`, 'post');

            // Success
            if (response.data.success) {
                getRegistrations();
                setShowSkeletonsRegistrations(false);
            }
        } catch (error) {
            // Error
            apiError(error);
        }
    }

    const handleReview = async (status_id, opmerking) => {
        //Call API
        //console.log("handle review");
        setShowSkeletonsRegistrations(true);
        try {
            const response = await apiCall(`registratie/beoordelen?code=${code}&uren_ids=${JSON.stringify(checkedIds)}&status_id=${status_id}&opmerking=${opmerking}`, 'post');

            // Success
            if (response.data.success) {
                //window.location.reload();

            }
            getRegistrations();
            setCheckedIds([]);
            setShowSkeletonsRegistrations(false);
        } catch (error) {
            // Error
            apiError(error);
        }
    }

    const renderModal = (uren_ids, status_id) => {
        const obj = {
            uren_ids: uren_ids,
            status_id: status_id
        }
        setModalData(obj);
        setShowModal(showModal + 1);
        //console.log("Show modal");
    }

    const renderOfferHoursModel = (id) => {
        const obj = {
            id: id,
            submitDate: submitDate
        }
        setModalDataOfferHours(obj);
        setShowModalOfferHours(showModalOfferHours + 1);
    }

const handleSelectAll = () => {
  const newCheckAll = !checkAll;
  setCheckAll(newCheckAll);

  const newChecked = {};
  const newIds = [];

  if (newCheckAll) {
    sortedRegistrations.forEach((row) => {
      if (row.review_status && row.afgeboekt == 1) {
        newChecked[row.id] = true;
        newIds.push(row.id);
      }
    });
  }

  setCheckedRows(newChecked);
  setCheckedIds(newIds);
};

const handleRowCheckboxChange = (id) => {
  setCheckedRows((prev) => {
    const next = { ...prev };

    if (next[id]) {
      delete next[id];
      setCheckedIds((prevIds) => prevIds.filter((x) => x !== id));
    } else {
      next[id] = true;
      setCheckedIds((prevIds) => [...prevIds, id]);
    }

    return next;
  });
};

    const handlePeriodChange = (event) => {
        const period = event.target.value;
        setSelectedPeriod(period);
        //console.log("periode: " + period);
        if(period == '11'){ // Controleer of periode 11 is geselecteerd
            setShowWeekDropdown(true);
        } else {
            setShowWeekDropdown(false);
            setSelectedWeek(getWeek(new Date())); // Reset weeknummer naar de huidige week
        }
    };

    const handleEmployeeChange = (event) => {
        setSelectedEmployee(event.target.value);
    };

    const handleLocationChange = (event) => {
        setSelectedLocation(event.target.value);
    };

    const handleClientChange = (event) => {
        setSelectedClient(event.target.value);
    };

    const handleConstructionNumberChange = (event) => {
        setSelectedConstructionNumber(event.target.value);
    };

    const handleDeckChange = (event) => {
        setSelectedDeck(event.target.value);
    };

    const handleHourTypeChange = (event) => {
        setSelectedHourType(event.target.value);
    };

    const handleStatusChange = (event) => {
        setSelectedStatus(event.target.value);
    };

    const handleActiveStatusChange = (event) => {
        setSelectedActiveStatus(event.target.value);
    };

    const resetFilters = () => {
        setSelectedPeriod(default_period);
        setSelectedEmployee(userId);
        setSelectedLocation(0);
        setSelectedClient(0);
        setSelectedConstructionNumber(0);
        setSelectedDeck(0);
        setSelectedHourType(0);
        setSelectedStatus(0);
        setSelectedActiveStatus(1);
        setPerPage(50);
        setPage(1);
    };

    const handleSort = (column_name) => {
        /*if(column_name !== order_by_name){
            setOrderBy('asc');
            setOrderByName(column_name);
        } else {
            setOrderBy((prevOrderBy) => (prevOrderBy === 'desc' ? 'asc' : 'desc'));
        }*/
    };

    useEffect(() => {
      setPage(1);
    }, [selectedPeriod, selectedWeek, selectedEmployee, selectedLocation, selectedClient, selectedConstructionNumber, selectedDeck, selectedHourType, selectedStatus]);


    useEffect(() => {
        if (loggedIn !== 'true') {
            navigate('/login');
        }
        setInterval(() => setDate(new Date()), 30000);
        getRegistrations();
    }, [page, perPage, selectedPeriod, selectedWeek, selectedEmployee, selectedLocation, selectedClient, selectedConstructionNumber, selectedDeck, selectedHourType, selectedStatus, selectedActiveStatus]);

    const getCaretIcon = (columnName) => {
        if(order_by_name === columnName){
            return order_by === 'asc' ? <Icon.CaretUpFill /> : <Icon.CaretDownFill />;
        }
        return null;
    };

    const isFilterSelected = () => {
        return (
            selectedPeriod !== default_period ||
            selectedEmployee !== userId ||
            selectedLocation !== 0 ||
            selectedClient !== 0 ||
            selectedConstructionNumber !== 0 ||
            selectedDeck !== 0 ||
            selectedHourType !== 0 ||
            selectedStatus !== 0 ||
            selectedActiveStatus !== 1
        );
    };

    const sortedRegistrations = React.useMemo(() => {
      const copy = [...registrations];

      copy.sort((a, b) => {
        // 1) medewerker
        const empA = (a.medewerker || '').toLowerCase();
        const empB = (b.medewerker || '').toLowerCase();
        if (empA !== empB) return empA > empB ? 1 : -1;

        // 2) week (week_year + week)
        const wyA = (a.week_year ?? 0) * 100 + (a.week ?? 0);
        const wyB = (b.week_year ?? 0) * 100 + (b.week ?? 0);
        if (wyA !== wyB) return wyB - wyA; // desc (meest recente week eerst)

        // 3) datum (YYYY-MM-DD string; desc)
        const dA = a.datum || '';
        const dB = b.datum || '';
        if (dA !== dB) return dB.localeCompare(dA);

        // 4) fallback: id desc
        return (b.id ?? 0) - (a.id ?? 0);
      });

      return copy;
    }, [registrations]);


    const rowsWithGroups = React.useMemo(() => {
      // 1) Sorteer stabiel: medewerker -> week desc -> datum desc -> id desc
      const sorted = [...registrations].sort((a, b) => {
        const empA = (a.medewerker || '').toLowerCase();
        const empB = (b.medewerker || '').toLowerCase();
        if (empA !== empB) return empA > empB ? 1 : -1;

        const wkA = (a.week_year ?? 0) * 100 + (a.week ?? 0);
        const wkB = (b.week_year ?? 0) * 100 + (b.week ?? 0);
        if (wkA !== wkB) return wkB - wkA; // nieuwste week eerst

        const dA = a.datum || '';
        const dB = b.datum || '';
        if (dA !== dB) return dB.localeCompare(dA); // nieuwste dag eerst

        return (b.id ?? 0) - (a.id ?? 0);
      });

      // 2) Buffer structuur: employee -> week -> day
      // We bewaren ook de originele rows per dag (in volgorde)
      const employees = new Map();

      for (const row of sorted) {
        const empKey = row.medewerker_id ?? row.medewerker;
        const weekKey = `${row.week_year}-${row.week}`;
        const dayKey = row.datum; // YYYY-MM-DD

        const hours = parseFloat(row?.aantal_uren?.value ?? 0);

        if (!employees.has(empKey)) {
          employees.set(empKey, {
            employeeName: row.medewerker || '',
            weeks: new Map(),
          });
        }

        const emp = employees.get(empKey);

        if (!emp.weeks.has(weekKey)) {
          emp.weeks.set(weekKey, {
            weekLabel: row.week_label || `Week ${row.week} (${row.week_year})`,
            weekYear: row.week_year,
            week: row.week,
            total: 0,
            days: new Map(),
          });
        }

        const wk = emp.weeks.get(weekKey);
        wk.total += hours;

        if (!wk.days.has(dayKey)) {
          wk.days.set(dayKey, {
            dayLabel: row.datum_nl || row.datum,
            total: 0,
            rows: [],
          });
        }

        const day = wk.days.get(dayKey);
        day.total += hours;
        day.rows.push(row);
      }

      // 3) Flatten naar “render-rows”:
      // medewerker header -> week header (met weektotaal) -> dag header (met dagtotaal) -> detail rows
      const out = [];

      let dayStripeIndex = 0;
      for (const [empKey, emp] of employees.entries()) {
        out.push({
          __type: 'employee_header',
          __key: `emp-${empKey}`,
          label: emp.employeeName,
        });

        // weeks in gewenste volgorde: week desc
        const weekList = Array.from(emp.weeks.entries()).sort((a, b) => {
          const wkA = (a[1].weekYear ?? 0) * 100 + (a[1].week ?? 0);
          const wkB = (b[1].weekYear ?? 0) * 100 + (b[1].week ?? 0);
          return wkB - wkA;
        });

        for (const [weekKey, wk] of weekList) {
          out.push({
            __type: 'week_header',
            __key: `week-${empKey}-${weekKey}`,
            week_label: wk.weekLabel,
            totaal_uren: wk.total.toFixed(2),
          });

          // days in gewenste volgorde: datum desc
          const dayList = Array.from(wk.days.entries()).sort((a, b) => b[0].localeCompare(a[0]));

          for (const [dayKey, day] of dayList) {
            const stripe = dayStripeIndex % 2 === 0 ? 'day-even' : 'day-odd';
            dayStripeIndex++;

            out.push({
              __type: 'day_header',
              __key: `day-${empKey}-${weekKey}-${dayKey}`,
              datum_nl: day.dayLabel,
              totaal_uren: day.total.toFixed(2),
              __stripe: stripe,
            });

            // detailregels
            for (const r of day.rows) {
                out.push({ ...r, __stripe: stripe });
            }
          }
        }
      }

      return out;
    }, [registrations]);


    const rowsWithSubtotals = React.useMemo(() => {
      // Alleen zinvol als je op datum groepeert (anders worden subtotalen “random”)
      if(order_by_name !== 'datum') return sortedRegistrations;

      const out = [];
      let currentKey = null;
      let subtotal = 0;
      let currentDateNl = '';
      let currentEmployee = '';

      const pushSubtotal = () => {
        if(!currentKey) return;
        out.push({
            __type: 'subtotal',
            __key: `subtotal-${currentKey}`,
            datum_nl: currentDateNl,
            medewerker: currentEmployee,
            totaal_uren: subtotal.toFixed(2),
        });
      };

      // Zorg dat rows per datum + medewerker bij elkaar staan
      // (jouw sort is nu op 1 kolom; als dat datum is, is dit ok)
      sortedRegistrations.forEach((row) => {
        const key = `${row.datum}|${row.medewerker}`; // datum = database_datum (YYYY-MM-DD)
        if(currentKey !== key){
            pushSubtotal();
            currentKey = key;
            subtotal = 0;
            currentDateNl = row.datum_nl;
            currentEmployee = row.medewerker;
        }

        subtotal += parseFloat(row?.aantal_uren?.value ?? 0);
        out.push(row);
      });

      pushSubtotal();
      return out;
    }, [sortedRegistrations, order_by_name]);

    return(
        <div>
            <Header />
            <div className="main">
                <div className="container">
                    <div className="content">
                        <div className="filters">
                            {/* Filters*/}
                            <div className="dropdown-container">
                                <Dropdown
                                    compact
                                    placeholder={t('select_period', 'Select a period')}
                                    value={selectedPeriod}
                                    label={t('which_period', 'Which period?')}
                                    onChange={handlePeriodChange}
                                    source={periods}
                                />
                            </div>
                            {/* Weeknummer dropdown, alleen zichtbaar als periode 11 is geselecteerd */}
                            {showWeekDropdown && (
                                <div className="dropdown-container">
                                    <Dropdown
                                        compact
                                        placeholder={t('select_week_number', 'Select a week number')}
                                        value={selectedWeek}
                                        label={t('which_week', 'Which week?')}
                                        onChange={(event) => setSelectedWeek(event.target.value)}
                                        source={week_numbers}
                                    />
                                </div>
                            )}
                            <div className="dropdown-container">
                                <Dropdown
                                    compact
                                    placeholder={t('select_employee', 'Select an employee')}
                                    value={selectedEmployee}
                                    label={t('which_employee', 'Which employee?')}
                                    onChange={handleEmployeeChange}
                                    source={employees}
                                />
                            </div>
                            <div className="dropdown-container">
                                <Dropdown
                                    compact
                                    placeholder={t('select_location', 'Select a location')}
                                    value={selectedLocation}
                                    label={t('which_location_q', 'Which location?')}
                                    onChange={handleLocationChange}
                                    source={locations}
                                />
                            </div>
                            <div className="dropdown-container">
                                <Dropdown
                                    compact
                                    placeholder={t('select_client', 'Select a client')}
                                    value={selectedClient}
                                    label={t('which_client_q', 'Which client?')}
                                    onChange={handleClientChange}
                                    source={clients}
                                />
                            </div>
                            <div className="dropdown-container">
                                <Dropdown
                                    compact
                                    placeholder={t('select_construction_number', 'Select a construction number')}
                                    value={selectedConstructionNumber}
                                    label={t('which_construction_number_q', 'Which construction number?')}
                                    onChange={handleConstructionNumberChange}
                                    source={construction_numbers}
                                />
                            </div>
                            <div className="dropdown-container">
                                <Dropdown
                                    compact
                                    placeholder={t('select_deck', 'Select a deck')}
                                    value={selectedDeck}
                                    label={t('which_deck_q', 'Which deck?')}
                                    onChange={handleDeckChange}
                                    source={decks}
                                />
                            </div>
                            <div className="dropdown-container">
                                <Dropdown
                                    compact
                                    placeholder={t('select_hour_type', 'Select an hour type')}
                                    value={selectedHourType}
                                    label={t('hour_type', 'Hour type')}
                                    onChange={handleHourTypeChange}
                                    source={hour_types}
                                    internExtern={true}
                                />
                            </div>
                            <div className="dropdown-container">
                                <Dropdown
                                    compact
                                    placeholder={t('select_status', 'Select a status')}
                                    value={selectedStatus}
                                    label={t('which_status', 'Which status?')}
                                    onChange={handleStatusChange}
                                    source={statusses}
                                />
                            </div>
                            <div className="dropdown-container">
                                <Dropdown
                                    compact
                                    placeholder={t('select_active_status', 'Select a active status')}
                                    value={selectedActiveStatus}
                                    label={t('which_active_status', 'Which active status?')}
                                    onChange={handleActiveStatusChange}
                                    source={activeStatusses}
                                />
                            </div>
                            <div className="dropdown-container">
                                <Dropdown
                                    compact
                                    placeholder="Per page"
                                    value={perPage}
                                    label="Per page"
                                    onChange={(e) => { setPerPage(parseInt(e.target.value, 10)); setPage(1); }}
                                    source={[
                                      { value: 25, label: '25', actief: 1 },
                                      { value: 50, label: '50', actief: 1 },
                                      { value: 100, label: '100', actief: 1 },
                                      { value: 200, label: '200', actief: 1 },
                                    ]}
                                />
                            </div>

                            {/* Wis filters */}
                            {isFilterSelected() && (
                                <div className="reset-filters-container">
                                    <button type="button" onClick={resetFilters} className="reset-filters-button">
                                        {t('clear_filters', 'Clear filters')}
                                    </button>
                                </div>
                            )}
                        </div>
                        {/*loadingRegistrations ?
                            <Watch
                                height="20"
                                width="20"
                                radius="48"
                                color="#13A3F6"
                                ariaLabel="watch-loading"
                                wrapperStyle={{}}
                                wrapperClassName=""
                                visible={true}
                            />
                        : null*/}
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="th-checkbox">
                                        <input type='checkbox' checked={checkAll} onChange={handleSelectAll} />
                                    </th>
                                    <th className="width-50" onClick={() => handleSort('datum')}>
                                        <span className="th-content">{t('date', 'Date')} {getCaretIcon('datum')}</span>
                                    </th>
                                    <th onClick={() => handleSort('medewerker')}>
                                        <span className="th-content">{t('employee', 'Employee')} {getCaretIcon('medewerker')}</span>
                                    </th>
                                    <th onClick={() => handleSort('locaties')}>
                                        <span className="th-content">{t('location', 'Location')} {getCaretIcon('locaties')}</span>
                                    </th>
                                    <th onClick={() => handleSort('klanten')}>
                                        <span className="th-content">{t('client', 'Client')} {getCaretIcon('klanten')}</span>
                                    </th>
                                    <th onClick={() => handleSort('bouwnummers')}>
                                        <Tooltip title={t('construction_number', 'Construction number')} className="tooltip-th" arrow>
                                            <span className="th-content">
                                                {t('cn_short', 'Cn')} {getCaretIcon('bouwnummers')}
                                            </span>
                                        </Tooltip>
                                    </th>
                                    <th onClick={() => handleSort('dekken')}>
                                        <span className="th-content">{t('deck', 'Deck')} {getCaretIcon('dekken')}</span>
                                    </th>
                                    <th onClick={() => handleSort('uren_soorten')}>
                                        <span className="th-content">{t('hour_type_col', 'Hour type')} {getCaretIcon('uren_soorten')}</span>
                                    </th>
                                    <th onClick={() => handleSort('opmerking')}>
                                        <span className="th-content">{t('notes', 'Notes')} {getCaretIcon('opmerking')}</span>
                                    </th>
                                    <th onClick={() => handleSort('aantal_uren')} className='exclude'>
                                        <span className="th-content">{t('hours', 'Hours')} {getCaretIcon('aantal_uren')}</span>
                                    </th>
                                    <th onClick={() => handleSort('uren_status')} className='exclude'>
                                        <span className="th-content">{t('status', 'Status')} {getCaretIcon('uren_status')}</span>
                                    </th>
                                    <th onClick={() => handleSort('review_status')} className='exclude'>
                                        <span className="th-content">{t('my_review', 'My review')} {getCaretIcon('review_status')}</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {showSkeletonsRegistrations ? (
                                    <>
                                        <TableRowSkeleton/>
                                        <TableRowSkeleton/>
                                        <TableRowSkeleton/>
                                    </>
                                ) : sortedRegistrations && sortedRegistrations.length > 0 ? (
                                    <>
                                        {rowsWithGroups.map((row) => {
                                          if (row.__type === 'employee_header') {
                                            return (
                                              <tr key={row.__key} className="group-employee">
                                                <td colSpan={12}><strong>{row.label}</strong></td>
                                              </tr>
                                            );
                                          }

                                          if (row.__type === 'week_header') {
                                            return (
                                              <tr key={row.__key} className="group-week">
                                                <td></td>
                                                <td colSpan={8}><strong>{row.week_label}</strong></td>
                                                <td className="exclude"><strong>{row.totaal_uren}</strong></td>
                                                <td colSpan={2}></td>
                                              </tr>
                                            );
                                          }

                                            if (row.__type === 'day_header') {
                                              return (
                                                <tr key={row.__key} className={`group-day ${row.__stripe}`}>
                                                  <td></td>
                                                  <td colSpan={8}><strong>{row.datum_nl}</strong></td>
                                                  <td className="exclude"><strong>{row.totaal_uren}</strong></td>
                                                  <td colSpan={2}></td>
                                                </tr>
                                              );
                                            }

                                          return (
                                            <DayRowOverview
                                              key={row.id}
                                              registration={row}
                                              option={row}
                                              showDate={showDate}
                                              deleteRow={deleteRow}
                                              renderModal={renderModal}
                                              isChecked={!!checkedRows[row.id]}
                                              onCheckboxChange={() => handleRowCheckboxChange(row.id)}
                                              hideDate={true}
                                              rowClassName={row.__stripe}
                                            />
                                          );
                                        })}
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td className='exclude'>{totalHours}</td>
                                            <td></td>
                                        </tr>
                                    </>
                                ) : (
                                    <tr>
                                        <td colSpan="2" className="no-registrations-overview">{t('no_results', 'No results')}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {pagination && (
                          <div className="pagination-bar">
                            <button
                              className="pagination-btn"
                              disabled={pagination.current_page <= 1}
                              onClick={() => setPage((p) => p - 1)}
                            >
                              ‹ {t('pagination_prev', 'Prev')}
                            </button>

                            <span className="pagination-info">
                              {t('pagination_page', 'Page')} <strong>{pagination.current_page}</strong> / {pagination.last_page}
                              <span className="pagination-total">({pagination.total} {t('pagination_rows', 'rows')})</span>
                            </span>
                            <button
                              className="pagination-btn"
                              disabled={pagination.current_page >= pagination.last_page}
                              onClick={() => setPage((p) => p + 1)}
                            >
                              {t('pagination_next', 'Next')} ›
                            </button>
                          </div>
                        )}
                        <Artwork />
                    </div>
                    <div className={`fixed-bottom-right ${checkedIds.length > 0 ? 'show-buttons' : ''}`}>
                        <button className="open" onClick={() => handleReview(0)}>{t('open', 'Open')}</button>
                        <button className="approved" onClick={() => handleReview(2)}>{t('approve', 'Approve')}</button>
                        <button className="rejected" onClick={() => renderModal(checkedIds, 3)}>{t('reject', 'Reject')}</button>
                    </div>
                </div>
            </div>

            {/* Component bottom menu */}
            <BottomMenu />

            {/* Backdrop */}
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={openBackdrop}>
                <Watch
                    height="80"
                    width="80"
                    radius="48"
                    color="white"
                    ariaLabel="watch-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                />
            </Backdrop>

            {/* Modal to modify registration line */}
            {showModal > 0 ?
                <ModalReviewHours show={showModal} data={modalData} getRegistrations={getRegistrations} />
            :
                null
            }

            {/* Modal to offer hours for the day */}
            {/*
                showModalOfferHours > 0 ?
                <ModalOfferHours show={showModalOfferHours} data={modalDataOfferHours} getRegistrations={getRegistrations} submitDate={submitDate} />
                :
                null
            */}
            <ToastContainer transition={Slide}/>
        </div>
    );
}

export default Overview;
